const RELOAD_FLAG_KEY = "przezmorze:stale-chunk-reload";

export function handleStaleChunkError(
  event: VitePreloadErrorEvent,
  reload: () => void = () => window.location.reload(),
  storage: Storage = window.sessionStorage,
): void {
  if (storage.getItem(RELOAD_FLAG_KEY)) {
    // Reloading already failed to recover this session; let Sentry capture it as unrecoverable.
    return;
  }
  storage.setItem(RELOAD_FLAG_KEY, "true");
  event.preventDefault();
  reload();
}

export function registerStaleChunkReload(): void {
  window.addEventListener("vite:preloadError", (event) => handleStaleChunkError(event));
}
